export enum CLASSIFICATION_ENUM {
  Critical = 'Critical',
  Major = 'Major',
  Minor = 'Minor',
  Other = 'Other',
}

export const STATUS = {
  ACTIVE: {
    key: 1,
    text: 'Active',
    value: 'Active',
  },
  INACTIVE: {
    key: 2,
    text: 'InActive',
    value: 'InActive',
  },
  PENDING: {
    key: 3,
    text: 'Archive',
    value: 'Archive',
  },
}

export const DISPLAY_STATUS = {
  ACTIVE: {
    key: 1,
    text: 'Active',
    value: 'Active',
  },
  INACTIVE: {
    key: 2,
    text: 'InActive',
    value: 'InActive',
  },
}

export const PBF_DISPLAY_STATUS = {
  ACTIVE: {
    key: 1,
    text: 'Active',
    value: 'active',
  },
  INACTIVE: {
    key: 2,
    text: 'InActive',
    value: 'inactive',
  },
}

export const STATUS_LIST = [
  {
    key: 1,
    text: 'Active',
    value: 'Active',
  },
  {
    key: 2,
    text: 'InActive',
    value: 'InActive',
  },
  {
    key: 3,
    text: 'Pending',
    value: 'Pending',
  },
]

export const INSPECTION_SECTION_RESULT = {
  RESULT_OBJECT: {
    'N/A': 'N/A',
    PENDING: 'PENDING',
    FAIL: 'FAIL',
    PASS: 'PASS',
    CIO: 'CIO',
  },
  DEFECT_CRITICALITY: {
    CRITICAL: CLASSIFICATION_ENUM.Critical.toUpperCase(),
    MAJOR: CLASSIFICATION_ENUM.Major.toUpperCase(),
    MINOR: CLASSIFICATION_ENUM.Minor.toUpperCase(),
    OTHER: CLASSIFICATION_ENUM.Other.toUpperCase(),
  },
  RESULT_ARRAY: ['PASS', 'FAIL', 'PENDING', 'N/A'],
}

export const CLASSIFICATION = [
  {
    label: CLASSIFICATION_ENUM.Critical,
    value: CLASSIFICATION_ENUM.Critical,
  },
  {
    label: CLASSIFICATION_ENUM.Major,
    value: CLASSIFICATION_ENUM.Major,
  },
  {
    label: CLASSIFICATION_ENUM.Minor,
    value: CLASSIFICATION_ENUM.Minor,
  },
  {
    label: CLASSIFICATION_ENUM.Other,
    value: CLASSIFICATION_ENUM.Other,
  },
]
